import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import Sanitize from '@/src/shared/components/Sanitize';

import style from '../style';

const SmartBrief = ({ designData }) => {
  const { block, blockComponents } = designData;

  return (
    <div css={style.rowWidth}>
      <Heading type={2} theme="primaryGray" size="md" weight="bold">
        {block.BlockTitle}
      </Heading>
      {blockComponents.map(c => (
        <div key={c.BlockComponentId} css={style.description}>
          <Sanitize>{c.Paragraph}</Sanitize>
        </div>
      ))}
    </div>
  );
};

SmartBrief.propTypes = {
  designData: PropTypes.objectOf({
    block: PropTypes.object.isRequired,
    blockComponents: PropTypes.array.isRequired,
  }).isRequired,
};

export default SmartBrief;
